const SET_NO_EVENTS = (state, payload) => {
  state.noEvents = payload;
};

export default SET_NO_EVENTS;
